import Grid from '@material-ui/core/Grid'
import Image from 'next/legacy/image'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { irem } from '../../../utils'
import { html } from '../../../utils/html'
import { ColumnFeatureFragment } from '@gql'

const StyledImageContainer = styled.div`
  max-width: ${irem(400)};
  margin: 0 auto;
  position: absolute;
  bottom: ${props => props.theme.typography.pxToRem(-72)};
  width: ${props => props.theme.typography.pxToRem(520)};

  ${props => props.theme.breakpoints.up('lg')} {
    max-width: none;
  }

  img {
    width: 100%;
    height: 100%;
    max-height: 550px;
    object-fit: cover;
  }
`

const StyledColumnFeature = styled(Grid)`
  padding-bottom: ${props => props.theme.typography.pxToRem(61)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding-bottom: 0;
  }

  > div:last-child {
    padding: ${props => props.theme.typography.pxToRem(20)};

    ${props => props.theme.breakpoints.up('sm')} {
      padding: 0;
    }
  }
`

const StyledComponentDetails = styled(Grid)`
  padding: ${props => props.theme.typography.pxToRem(67)} ${props => props.theme.typography.pxToRem(81)};
  background: white;
  border-radius: 12px;

  h5 {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: ${props => props.theme.typography.pxToRem(43)};
  }

  h2 {
    color: ${props => props.theme.palette.secondary.dark};
    font-size: ${props => props.theme.typography.pxToRem(32)};
    font-style: normal;
    font-weight: 600;
    margin-bottom: ${props => props.theme.typography.pxToRem(26)};
  }
`

export type ColumnFeatureProps = {
  data: ColumnFeatureFragment[]
}

export const ColumnFeature: React.FC<PropsWithChildren<ColumnFeatureProps>> = ({ data }) => {
  if (!data[0]) {
    return null
  }

  const { leftColumn, rightColumn } = data[0]

  return (
    <StyledColumnFeature container direction="row" alignItems="center" spacing={8}>
      <StyledComponentDetails item xs={12} md={5}>
        {leftColumn && html(leftColumn)}
      </StyledComponentDetails>
      <Grid item xs={12} md={7}>
        {rightColumn?.[0]?.url && rightColumn[0]?.__typename === 'images_Asset' && (
          <StyledImageContainer>
            <Image height={rightColumn[0].height ?? 683} width={rightColumn[0].width ?? 621} objectFit="contain" src={rightColumn[0].url} alt={rightColumn[0].alt ?? ''} />
          </StyledImageContainer>
        )}
      </Grid>
    </StyledColumnFeature>
  )
}